import React, { useEffect } from "react";
import { useState } from "react";
import ExcelJS from "exceljs";
import ModalComponent from "../../Common/popup_modal/ModalComponent";
import { AllocatedVehicleStore } from "./AllocatedVehicleStore";
import AllocatedForm from "./AllocatedForm";
import AllocatedVehicleTable from "./AllocatedVehicleTable";

const AllotedVechicle = () => {
  const [showModal, setShowModal] = useState(false);

  const {
    fetchAllocatedVehicles,
    AllocatedVehicles,
    isFetchAllocatedVehiclesLoading,
  } = AllocatedVehicleStore();

  useEffect(() => {
    fetchAllocatedVehicles();
  }, [fetchAllocatedVehicles]);

  const tableData = AllocatedVehicles;

  const downloadExcel = async () => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Alloted Vehicle Details");

  const now = new Date();
  const generatedOn = `Report Generated on: ${now.getDate()}-${now.getMonth() + 1}-${now.getFullYear()} ${now.getHours()}:${String(now.getMinutes()).padStart(2, "0")}`;

  const centerAlign = {
    alignment: { horizontal: "center", vertical: "middle", wrapText: true },
  };

  const TOTAL_COLS = 8;

  // Title
  const titleRow = worksheet.addRow(["Alloted Vehicle Details"]);
  worksheet.mergeCells(titleRow.number, 1, titleRow.number, TOTAL_COLS);
  titleRow.getCell(1).font = { bold: true, size: 13 };
  titleRow.getCell(1).alignment = centerAlign.alignment;

  // Generated On
  const genRow = worksheet.addRow([generatedOn]);
  worksheet.mergeCells(genRow.number, 1, genRow.number, TOTAL_COLS);
  genRow.getCell(1).alignment = centerAlign.alignment;

  worksheet.addRow([]);

 
  const headerRow = worksheet.addRow([
    "S.No",
    "Corporation",
    "Owner Type",
    "Shift",
    "Alloted Vehicle Count",
    "Date",
    "Zone",
    "Circle",
  ]);

  headerRow.eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = centerAlign.alignment;
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "F6B1B1" },
    };
    cell.border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
  });

  let sNo = 1;

  tableData.forEach((record) => {
    const circles = record.data || [];
    if (!circles.length) return;

    const startRow = worksheet.rowCount + 1;

    circles.forEach((circle, i) => {
      worksheet.addRow([
        i === 0 ? sNo : "",
        i === 0 ? record.corporationName : "",
        i === 0 ? record.ownerTypeName || "" : "",
        i === 0 ? record.shiftName || "" : "",
        circle.vehicleCount || 0,
        circle.date || record.date || "",
        circle.zoneName || "",
        circle.circleName || "",
      ]).eachCell((cell) => {
        Object.assign(cell, centerAlign);
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
      });
    });

    const endRow = worksheet.rowCount;

    // Merge first 4 columns (grouping)
    if (circles.length > 1) {
      [1, 2, 3, 4].forEach((col) => {
        worksheet.mergeCells(startRow, col, endRow, col);
        worksheet.getCell(startRow, col).alignment = centerAlign.alignment;
      });
    }

    sNo++;
  });

  // TOTAL ROW (FIXED ALIGNMENT)
  const totalCount = tableData.reduce(
    (sum, r) =>
      sum + (r.data || []).reduce((s, c) => s + (c.vehicleCount || 0), 0),
    0
  );

  const totalRow = worksheet.addRow([
    "",
    "",
    "",
    "",
    totalCount,
    "", 
    "Total",
    "",
  ]);

  totalRow.eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = centerAlign.alignment;
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "F6B1B1" },
    };
  });

  // COLUMN WIDTHS (FIXED ORDER)
  worksheet.columns = [
    { width: 7 },   // S.No
    { width: 20 },  // Corporation
    { width: 18 },  // Owner Type
    { width: 12 },  // Shift
    { width: 15 },  // Vehicle Count
    { width: 18 },  // Date
    { width: 22 },  // Zone
    { width: 25 },  // Circle
  ];

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "AllotedVehicleDetails.xlsx";
  a.click();
  URL.revokeObjectURL(url);
};

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className="row justify-content-end align-items-center mb-3">
                <div className="col-md-6 ">
                  <div className="d-flex align-items-center justify-content-end">
                    <button
                      className="button-container"
                      onClick={() => setShowModal(true)}
                    >
                      <i className="fa-solid fa-plus me-1 icon-container"></i>
                      Add Allocated Vehicle
                    </button>
                    <button
                      className="btn btn-excel ms-2"
                      onClick={downloadExcel}
                    >
                      <i className="fa-solid fa-file-excel me-1 icon-container"></i>
                      Excel
                    </button>
                  </div>
                </div>
              </div>

              <div
                className="card"
                style={{ borderRadius: "10px", overflow: "hidden" }}
              >
                <div className="card-body" style={{ padding: 0 }}>
                  <div
                    className="top-header"
                    style={{
                      padding: "12px 16px",
                      borderBottom: "1px solid #e0e0e0",
                      background:
                        "linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%)",
                    }}
                  >
                    <span
                      style={{
                        fontWeight: 600,
                        fontSize: "14px",
                        color: "#444",
                      }}
                    >
                      Alloted Vehicle Details
                    </span>
                  </div>

                  <AllocatedVehicleTable
                    tableData={tableData}
                    isLoading={isFetchAllocatedVehiclesLoading}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalComponent
        title="Add Allocated Vehicle"
        show={showModal}
        onHide={() => setShowModal(false)}
        handleClose={() => setShowModal(false)}
      >
        <AllocatedForm handleClose={() => setShowModal(false)} />
      </ModalComponent>
    </>
  );
};

export default AllotedVechicle;
